import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {Menu} from 'src/app/models/menu';
import {ProfileService} from 'src/app/core/profile/profile.service';
import {SidenavService} from "../../core/sidenav/sidenav.service";
import {MatSidenav} from "@angular/material/sidenav";
import {Router} from '@angular/router';
import {SocialAuthService} from "@abacritt/angularx-social-login";
import {BG} from 'src/environments/environment.prod';
import { OauthService } from 'src/app/core/oauth/oauth.service';
import {GoogleAuthenticationService} from "../../core/login/google-authentication.service";

@Component({
  standalone: false,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit{
  @ViewChild('sidenav') sidenav: MatSidenav;

  optionsMenu: Menu[];
  groupNameProfile: string = BG.setClient;
  rol: string;

  constructor(
    private _router: Router,
    private sidenavService: SidenavService,
    private authService: SocialAuthService,
    private profileService: ProfileService,
    private _oauthService: OauthService,
    private googleAuthenticationService: GoogleAuthenticationService) {

  }

  ngOnInit(): void {
    this.sidenavService.menuState.subscribe( async(isOpen: boolean) => {
      if(isOpen) {
        await this.sidenav.open();
      }
      else{
        await this.sidenav.close();
      }
    });

    this._oauthService.aoutUser().subscribe({
      next: (roles) => {
        this.rol = roles?.roles?.[0] ?? '';
        this.getOptionsMenu();
      },
      error: () => {
        this.rol = '';
        this.getOptionsMenu();
      }
    });
  }

  getOptionsMenu(): void{
    if(this.rol === 'admin') {
      this.groupNameProfile= BG.setAdm;
    }
    this.profileService.getOptionsMenu(this.groupNameProfile
        ).subscribe(response => {
      this.optionsMenu = response;
    });
  }

  ngAfterViewInit(): void {
    this.sidenav.open();
    this.sidenavService.silenceOpen();
  }

  selectOption(optionNumber: number): void{
    this.cleanMenuOptionsStyle();
    this.setOptionSelectedStyle(optionNumber);
    // Defer sidebar close to next microtask so routerLink navigation completes first
    Promise.resolve().then(() => this.sidenavService.close());
  }

  setOptionSelectedStyle(optionNumber: number){
    let element = <HTMLElement>document.getElementById('option_' + optionNumber);
    element.setAttribute('class', 'menu-option-selected');
  }

  cleanMenuOptionsStyle(): void{
    for(let i = 0; i < this.optionsMenu.length; i++){
      let element: HTMLElement = <HTMLElement>document.getElementById('option_' + i);
      element.setAttribute('class', 'menu-option');
    }
  }

  closeSideNav(): void{
    this.sidenavService.close();
  }

  openSideNav(): void{
    this.sidenavService.open();
  }

  salir(){
    this.authService.signOut().then().catch();
    this.googleAuthenticationService.logout();
    this._router.navigate(['/']);
    localStorage.clear();
  }
}
